export default __webpack_public_path__ + "static/media/ie-circle.027ad7d3.svg";